import { ReactNode } from "react";

/**
 * @component DefaultResultsSection
 * @description Wrapper for default and compact result view modes
 */
const DefaultResultsSection = ({ children }: { children: ReactNode }) => {
  return (
    <div
      data-testid="search-results-list"
      className="flex flex-col w-full items-center px-4"
    >
      <div className="flex flex-col w-full items-center max-w-page">
        {children}
      </div>
    </div>
  );
};

export default DefaultResultsSection;
